export const getRandomHexColor = () =>
  `#${Math.floor(Math.random() * 256 ** 3)
    .toString(16)
    .padStart(6, '0')}`;
